
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PostItemProps } from ".";
import { loading, update } from "store/post";

interface ApiPostUpdateInputProps extends PostItemProps {
}

type ApiPostUpdateOutputProps = OutputBaseProps<{ item: PostItemProps; }, ApiPostUpdateInputProps>

export const apiPostUpdate = async (data: ApiPostUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiPostUpdateOutputProps>("/api/post/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};